module.exports = __webpack_public_path__ + "static/media/google-plus.9f639094.svg";